import Icon from '@/Icon';
import { clc } from '@/legacy/components/base/utils';

import styles from '@/legacy/components/new/styles.module.scss';

type Props = {
	className: string;
};

/* object 씀 */
const Crown = ({ className }: Props) => {
	return (
		<div className={clc(styles.crown, className)}>
			<Icon path="Sticker_Business_Crown_32" />
		</div>
	);
};

export default Crown;
